<template>
    <div>
        <plate v-for="item in plateList" :key="item.SnapshotID" :plateNo="row.PlateNo" :plate="item"></plate>
    </div>
</template>
<script>
import Plate from './Plate'

export default {
    name: 'plates-component',
    components: { Plate },
    props: {
        row: {},
    },
    data() {
        return {
            plateList: [],
        }
    },
    created() {
        this.getNumberPlate(this.row.CandidateID)
    },
    methods: {
        getNumberPlate(id) {
            this.$http.get(`/Snapshot/Candidate/${id}`).then(res => {
                this.plateList = res.data
            })
        },
    },
}
</script>
